    // ------ Product Warranties with Handlebars Templates ------ //
    import $ from 'jquery';
    jQuery.noConflict();

    export function handleProductWarranty() {
        // Track "Product Warranty Shown" once if warranty offers are visible on page
        var $warrantyButtons = $('body').find('.btn-product-warranty[data-action="add"]');
        if ($warrantyButtons.length > 0 && typeof window.ClassicAnalytics !== 'undefined' && typeof window.ClassicAnalytics.track === 'function') {
            var offerLocation = 'cart_page';
            if (window.location.pathname === '/checkout/onepage/' || window.location.pathname.indexOf('/checkout/onepage') === 0) {
                offerLocation = 'checkout_page';
            }

            // Build array of eligible products instead of just a count
            var eligibleProducts = [];
            $warrantyButtons.each(function() {
                var $btn = $(this);
                var cartItemId = $btn.attr('data-product-sku') || '';

                // Try cart page selector first (h2.product-name inside tr.cart-product-line-item)
                var $parent = $btn.closest('tr.cart-product-line-item');
                var productName = $parent.find('h2.product-name a, h2.product-name').first().text().trim();
                var productSku = $parent.attr('data-product') || '';
                var productId = $parent.attr('data-objectid') || '';

                // Fall back to checkout page selector (.review-product-name p inside .cart-product-line-item)
                if (!productName) {
                    $parent = $btn.closest('.cart-product-line-item');
                    productName = $parent.find('.review-product-name p').first().text().trim();
                    productId = $parent.attr('data-product-id') || '';
                    productSku = $parent.attr('data-product-sku') || '';
                }

                var qty = 1;
                var $qtyInput = $parent.find('input[name="cart[' + cartItemId + '][qty]"]');
                if ($qtyInput.length) {
                    // Cart page
                    qty = parseInt($qtyInput.val(), 10) || 1;
                } else {
                    // Checkout page
                    var $qtyEl = $parent.find('.review-product-qty');
                    if ($qtyEl.length) {
                        qty = parseInt($qtyEl.text().replace(/[^0-9]/g, ''), 10) || 1;
                    }
                }

                // warrantyAmount declared here scoped to this iteration
                var warrantyAmount = 0;
                var $warrantySection = $btn.closest('.review-product-warranty');
                var $warrantyPrice = $warrantySection.find('.cart-price .price, .review-product-warranty-price p strong');
                if ($warrantyPrice.length) {
                    var priceText = $warrantyPrice.first().text().replace(/[^0-9.]/g, '');
                    warrantyAmount = parseFloat(priceText) || 0;
                }

                eligibleProducts.push({
                    product_id: productId,
                    product_sku: productSku,
                    product_name: productName,
                    warranty_amount: warrantyAmount,
                    qty: qty 
                });
            });

            // eventData now includes eligible_products array and variant field
            var eventData = {
                offers_count: eligibleProducts.length,
                eligible_products: eligibleProducts,
                offer_location: offerLocation,
            };

            if (typeof window.ClassicAnalytics.log === 'function') {
                window.ClassicAnalytics.log('Product Warranty Shown event fired', eventData);
            }
            window.ClassicAnalytics.track('Product Warranty Shown', eventData);
        }

        $('body').find('.btn-product-warranty').bind('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $this = $(this);
            var sku = $this.attr('data-product-sku');
            var item = $this.attr('data-item');
            var action = $this.attr('data-action');
            var clickActions = ['add', 'remove'];
            var whenComplete = $this.attr('data-completed');
            var thisContent = $this.clone().html();
            var ajaxResult = (typeof whenComplete !== 'undefined' && whenComplete == 'reload' ? 'redirect' : 'xhr');
            var $thisRow = $('.cart-product-line-item-warranty-' + sku);
            var $prevSib = $thisRow.prev('tr');
            var url = $this.attr('data-remote');
            var productUrl = $('#cart-sidebar-products').attr('data-remote');
            var eventId;
            var $wrapper = $('#checkout-progress-wrapper');

            var itemSku = $this.attr('data-item');
            var productNameBeforeAjax = '';
            var productIdBeforeAjax = '';
            var productSkuBeforeAjax = '';
            var $warrantyDiv = $('#cart-product-line-item-warranty-add-' + itemSku);
            if ($warrantyDiv.length) {
                var $outerTr = $warrantyDiv.closest('tr.cart-product-line-item');
                productNameBeforeAjax = $outerTr.find('h2.product-name a, h2.product-name').first().text().trim();
                productIdBeforeAjax = $outerTr.attr('data-objectid') || '';
                productSkuBeforeAjax = $outerTr.attr('data-product') || '';
            }
            if (!productNameBeforeAjax) {
                var $productBlock = $('#checkout-review-table').find('.cart-product-line-item[data-item-id="' + itemSku + '"]');
                productNameBeforeAjax = $productBlock.find('.review-product-name p').first().text().trim();
                productIdBeforeAjax = $productBlock.attr('data-product-id') || '';
                productSkuBeforeAjax = $productBlock.attr('data-product-sku') || '';
            }

            switch (window.location.pathname) {
                case '/checkout/cart/':
                    eventId = 32;
                    break;
                case '/checkout/onepage/':
                    eventId = 34;
                    break;
                default:
                    eventId = null;
            }

            // Get remaining action after removing this click action
            clickActions.splice(clickActions.indexOf(action), 1);

            var $span = $this.closest('.warranty-action');
            var $spanContent = $span.html();
            // Provide feedback for click
            $span.html('<span class="warranty-action-feedback">' + (action == 'add' ? 'Adding...' : 'Removing') + '</span>');
            $('.loading-overlay').show();
            $wrapper.addClass('is-loading');
            $.ajax({
                type: 'GET',
                url: url + action,
                data: {
                    sku: sku,
                    item: item,
                    ajaxResult: ajaxResult,
                    eventId: eventId
                },
                dataType: 'json'
            }).done(function (data) {

                if (typeof data.error === 'undefined') {
                    // Track Product Warranty event
                    if (action === 'add' && typeof window.ClassicAnalytics !== 'undefined' && typeof window.ClassicAnalytics.track === 'function') {
                        var warrantyAmount = 0;
                        var quantity = 1;

                        // Try to get warranty amount from the warranty price text
                        // Cart page uses .cart-price, checkout page uses p strong
                        var $warrantySection = $this.closest('.review-product-warranty');
                        var $warrantyPrice = $warrantySection.find('.cart-price');
                        if (!$warrantyPrice.length) {
                            // Checkout page: price is in <p>...<strong>$140.00</strong></p>
                            $warrantyPrice = $warrantySection.find('.review-product-warranty-price p strong');
                        }
                        if ($warrantyPrice.length) {
                            var priceText = $warrantyPrice.text().replace(/[^0-9.]/g, '');
                            warrantyAmount = parseFloat(priceText) || 0;
                        }

                        // If we got data from the response, use that (more reliable)
                        if (data.item) {
                            if (data.item.price) {
                                // Price comes as formatted string like "$35.00" or "35.00"
                                var priceFromResponse = String(data.item.price).replace(/[^0-9.]/g, '');
                                warrantyAmount = parseFloat(priceFromResponse) || warrantyAmount;
                            }
                            if (data.item.qty) {
                                quantity = parseInt(data.item.qty) || 1;
                            }
                        }

                        // Determine offer location based on current page
                        var offerLocation = 'cart_page';
                        if (window.location.pathname === '/checkout/onepage/' || window.location.pathname.indexOf('/checkout/onepage') === 0) {
                            offerLocation = 'checkout_page';
                        }

                        var eventData = {
                            warranty_name: data.item ? data.item.name : '',
                            product_name: productNameBeforeAjax,
                            product_id: productIdBeforeAjax,
                            product_sku: productSkuBeforeAjax,
                            warranty_amount: warrantyAmount,
                            quantity: quantity,
                            offer_location: offerLocation,
                        };

                        if (typeof window.ClassicAnalytics.log === 'function') {
                            window.ClassicAnalytics.log('Product Warranty event fired', eventData);
                        }
                        window.ClassicAnalytics.track('Product Warranty', eventData);
                    }

                    if (typeof whenComplete !== 'undefined' && whenComplete == 'reload') {
                        window.location.reload();
                        return;
                    } else {

                        // Add warranty to onepage checkout summary
                        var $warranty = '<div class="cart-product-line-item">' +
                            ' <div class="bs-styles"><div class="row review-product d-flex justify-content-end justify-content-md-between"><div class="d-none d-md-inline-flex col-md-auto align-items-center">' +
                            '<a title="' + data.item.name + '" class="review-product-image"><img src="../../skin/frontend/default/classic-arms-19/images/cf-warranty.png" alt="' + data.item.name + '"></a></div><div class="col-12 col-md-5 align-items-center"><div class="review-product-name"><p>' +
                            data.item.name + '</p>';

                        if (typeof data.item.options !== 'undefined' && data.item.options.length) {
                            $warranty += '<dl class="item-options">';

                            for (var o = 0; o <= data.item.options.length - 1; o++) {
                                $warranty += '<dt>Product</dt>' +
                                    '<dd>' + data.item.options[o] + '</dd>';
                            }

                            $warranty += '</dt>';
                        }

                        $warranty += '</div></div>' +
                            '<div class="col-auto align-items-center"><div class="review-product-qty">x' +
                            data.item.qty +
                            '</div></div>' +
                            '<div class="col-auto align-items-right text-right"><div class="review-product-price">' +
                            '<span class="cart-price"> <span class="price">' + data.item.price + '</span></span>' +
                            '</div></div>';

                        // Find parent product block by data-item-id (product blocks only, not warranty blocks)
                        var $productBlock = $('#checkout-review-table')
                            .find('.cart-product-line-item[data-item-id="' + item + '"]')
                            .filter(function () {
                                return $(this).find('.review-product-warranty, .review-product-warranty-added').length > 0;
                            })
                            .first();
                        if (!$productBlock.length && data.item.options && data.item.options.length) {
                            // Fallback: match by product name from warranty options
                            var parentProductName = String(data.item.options[0]).trim();
                            $('#checkout-review-table').find('.cart-product-line-item').each(function () {
                                if ($(this).find('.review-product-warranty, .review-product-warranty-added').length === 0) return;
                                var $p = $(this).find('.review-product-name p').first();
                                if ($p.length && $p.text().trim() === parentProductName) {
                                    $productBlock = $(this);
                                    return false; // break
                                }
                            });
                        }
                        var $newWarrantyRow;
                        if ($productBlock.length) {
                            $productBlock.after($warranty);
                            $newWarrantyRow = $productBlock.next();
                            // Replace "Add warranty" button with "warranty added" message
                            var $warrantySection = $productBlock.find('.review-product-warranty');
                            if ($warrantySection.length) {
                                $warrantySection.replaceWith(
                                    '<div class="col-12 col-md-8 align-items-center"><div class="review-product-warranty-added">' +
                                    '<span>A warranty for this product has already been added to your cart.</span></div></div>'
                                );
                            }
                        } else {
                            $('#checkout-review-table').append($warranty);
                            $newWarrantyRow = $('#checkout-review-table').children('.cart-product-line-item').last();
                        }

                        // Get minicart data with max 3 items default and reload handlebars templates
    
                        var join = productUrl.indexOf('?') > -1 ? '&' : '?';
                        var url100 = productUrl + join + 'limit=100';

                        $.ajax({
                            type: 'GET',
                            url: url100,
                            dataType: 'json'
                        }).done(function (data) {

                            // Minicart (sidebar)
                            var $miniCart = $('.header .cart.sidebar');
                            var qty = parseInt(data.items_qty, 10);
                            if (isNaN(qty)) {
                                qty = 0;
                            }
                            $('.header .cart.sidebar .minicart-item-count')
                                .text(qty)
                                .toggleClass('minicart-item-count--empty', qty < 1);

                            // Minicart subtotal
                            var $subTotal = $miniCart.find('.subtotal');
                            $subTotal.find('.price').html('$' + data.subtotal);

                            //Adjust subtotals onepage checkout
                            if ($('#shopping-cart-totals-table').length && data.totalsHtml) {
                                $('#shopping-cart-totals-table').replaceWith(data.totalsHtml);
                            }

                            if ($('#sidebar-order-totals').length && data.totalsHtml) {
                                $('#sidebar-order-totals').html(data.totalsHtml);
                            }

                            //Reload Warranties into product list
                            var productsTemplate = require("../../templates/products.handlebars");
                            var productsHtml = productsTemplate(data);
                            $("#cart-sidebar-products").html(productsHtml);

                            if (data && typeof data.items_qty !== 'undefined') {
                                $('#sidebar-items-dropdown .sidebar-items-toggle__count')
                                .text(data.items_qty);
                            }

                            var countText = data.items_qty == 1 ? '1 item' : data.items_qty + ' items';
                            $('.block-cart .cart-drawer .cart-count .amount').text(countText);
                                
                            // Reload new totals
                            // var totalsTemplate = require("./templates/totals.handlebars");
                            // var contextualHtml = totalsTemplate(data);
                            // $("#sidebar-data").html(contextualHtml);

                            // Reloading Cart Sidebar Count and Total for Mobile Cart
                            var mobileTemplate = require("../../templates/mobileCart.handlebars");
                            var mobileHtml = mobileTemplate(data);
                            $("#mobile-cart").html(mobileHtml);

                                if (typeof data.items !== 'undefined' && data.items.length) {
                                var $miniCartItems = $miniCart.find('#cart-sidebar');
                                $miniCartItems.find('li').remove();

                                for (var i = 0; i <= data.items.length - 1; i++) {
                                    try {
                                        var $li = '<li class="item">' +
                                            '<span class="product-image">' +
                                            '<img src="' + data.items[i].image_thumbnail + '" width="50" height="50" alt="' + data.items[i].name + '">' +
                                            '</span>' +
                                            '<div class="product-details">' +
                                            '<a href="' + data.items[i].cartRemoveLink + '" title="Remove This Item" onclick="return confirm(\'Are you sure you would like to remove this item from the shopping cart?\');" class="btn-remove">Remove This Item</a>' +
                                            // '<a href="' + data.items[i].cartEditLink + '" title="Edit item" class="btn-edit">Edit item</a>' +
                                            '<p class="product-name"><a href=' + data.items[i].url + '">' + data.items[i].name + '</a></p>' +
                                            '<strong>' + data.items[i].qty + '</strong> x' +
                                            '<span class="price">$' + data.items[i].price + '</span>' +
                                            '</div>' +
                                            '</li>';

                                        $miniCartItems.append($li);
                                    } catch (err) {
                                        console.log(err);
                                    }
                                }
                            }
                            $span.html('Successfully Added to Cart!');
                            $('.loading-overlay').hide();
                            $wrapper.removeClass('is-loading');
                            $('li.item:nth-child(1)').addClass("flash");
                            if ($newWarrantyRow && $newWarrantyRow.length) {
                                $newWarrantyRow.addClass("flash");
                            } else {
                                $('.cart-product-line-item:last-child').addClass("flash");
                            }
                        });

                        // Get modal cart data with max 100 items and reload handlebars template
                        $.ajax({
                            type: 'GET',
                            url: productUrl + '?limit=100',
                            dataType: 'json'
                        }).done(function (data) {
                            // Reload products modal
                            var productsModalTemplate = require("../../templates/productsModal.handlebars");
                            var productsModalHtml = productsModalTemplate(data);
                            $("#modal-cart-data").html(productsModalHtml);
                        });
                    }
                } else {
                    // alert('There was a problem ' + (action == 'add' ? 'adding' : 'removing') + ' the warranty to your product');

                    // Replace feedback with button
                    $span.html($spanContent);
                }
            });
        });
    };